import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { api } from "../../api/api";
import { IFoodMenu } from "./food.types";

export const FETCH_FOOD_LIST_PROGRESS = "FETCH_FOOD_LIST_PROGRESS";
export const FETCH_FOOD_LIST_SUCCESS = "FETCH_FOOD_LIST_SUCCESS";
export const FETCH_FOOD_LIST_FAILED = "FETCH_FOOD_LIST_FAILED";

export const fetchFoodListProgress = () => action(FETCH_FOOD_LIST_PROGRESS);
export const fetchFoodListSuccess = (data: IFoodMenu[], totalRecords: number) =>
  action(FETCH_FOOD_LIST_SUCCESS, {
    data,
    totalRecords,
  });
export const fetchFoodListFailed = () => action(FETCH_FOOD_LIST_FAILED);

export const fetchFoodListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    company_outlet_uuid?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      // const searchQuery = getSearchQuery(queryParams);
      dispatch(fetchFoodListProgress());
      dispatch(saveLoaderProgress());

      let url = "";
      // if (status !== "-1") {
      //   url += `&status=${status}`;
      // }
      if (searchValue.length > 0) {
        url += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (company_outlet_uuid) {
				url += `&company_outlet_uuid=${company_outlet_uuid}`;
			}
      let finalUrl =
        `/food/get-food-menu?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
        url;
      const res = await api.get(finalUrl);
      const data: IFoodMenu[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchFoodListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchFoodListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
export const upsertFoodAsync =
  (
    data: IFoodMenu,

    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      await api.post("/food/upsert-food-menu", {
        ...data,
      });

      const message = "Food saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_FOOD_PROGRESS = "FETCH_FOOD_PROGRESS";
export const FETCH_FOOD_SUCCESS = "FETCH_FOOD_SUCCESS";
export const FETCH_FOOD_FAILED = "FETCH_FOOD_FAILED";

export const fetchFoodProgress = () => action(FETCH_FOOD_PROGRESS);
export const fetchFoodSuccess = (data: IFoodMenu) =>
  action(FETCH_FOOD_SUCCESS, { data });
export const fetchFoodFailed = (errorMessage: string) =>
  action(FETCH_FOOD_FAILED, { errorMessage });

export const fetchFoodAsync =
  (food_uuid: string,company_outlet_uuid?: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchFoodProgress());
      dispatch(saveLoaderProgress());
      let url = `/food/get-food-menu?food_uuid=${food_uuid}`;
			if (company_outlet_uuid) {
				url += `&company_outlet_uuid=${company_outlet_uuid}`;
			}
			const res = await api.get(url);
			const data = res.data.data;
			if (data.length > 0) {
				dispatch(fetchFoodSuccess(data[0]));
			} else {
				dispatch(
					fetchFoodFailed(
						"Unfortunately, there are no records available at the moment."
					)
				);
			}
    } catch (err: any) {
      dispatch(fetchFoodFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_FOOD_STATE = "CLEAR_FOOD_STATE";
export const clearFoodState = () => action(CLEAR_FOOD_STATE);
